// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PermissionRequestsButton__link-ffa14f {
  justify-content: flex-start;
  padding: 8px 16px;
  border-radius: 0;
  width: 100%;
  height: initial;
}

.PermissionRequestsButton__icon-da0b6d {
  padding: 12px;
  border-radius: 100%;
  margin-inline-end: 12px;
  background-color: var(--addition-50_10);
}

.PermissionRequestsButton__text-container-c9970e {
  width: 100%;
}

.PermissionRequestsButton__requests-text-cf47ad {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.PermissionRequestsButton__requests-count-a6a423 {
  background: var(--brand-primary-40);
  color: var(--addition-50);
  font: var(--font-subtitle-3);
  width: 24px;
  height: 24px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/PermissionRequestsButton/PermissionsRequestsButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;AACF;;AAEA;EACE,WAAA;AACF;;AACA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AAEF;;AAAA;EACE,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGF","sourcesContent":[".link {\n  justify-content: flex-start;\n  padding: 8px 16px;\n  border-radius: 0;\n  width: 100%;\n  height: initial;\n}\n\n.icon {\n  padding: 12px;\n  border-radius: 100%;\n  margin-inline-end: 12px;\n  background-color: var(--addition-50_10);\n}\n\n.text-container {\n  width: 100%;\n}\n.requests-text {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.requests-count {\n  background: var(--brand-primary-40);\n  color: var(--addition-50);\n  font: var(--font-subtitle-3);\n  width: 24px;\n  height: 24px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `PermissionRequestsButton__link-ffa14f`,
	"icon": `PermissionRequestsButton__icon-da0b6d`,
	"text-container": `PermissionRequestsButton__text-container-c9970e`,
	"textContainer": `PermissionRequestsButton__text-container-c9970e`,
	"requests-text": `PermissionRequestsButton__requests-text-cf47ad`,
	"requestsText": `PermissionRequestsButton__requests-text-cf47ad`,
	"requests-count": `PermissionRequestsButton__requests-count-a6a423`,
	"requestsCount": `PermissionRequestsButton__requests-count-a6a423`
};
module.exports = ___CSS_LOADER_EXPORT___;
